import { toDate } from "../../../core/lib/format";

/** « 418 555 0134 » pour un numéro nord-américain (E.164 ou saisi librement) ; sinon tel quel. */
export function prettyPhone(raw: string): string {
  const digits = raw.replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "");
  return digits.length === 10
    ? `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`
    : raw;
}

/** Deux initiales d'un nom (« Marie Tremblay » → « MT ») ; « # » sans nom. */
export function initials(name: string | null | undefined): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  const lettres = parts
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
  return lettres || "#";
}

/** Heure si c'est aujourd'hui, sinon date courte : pour une liste de conversations. */
export function quand(at: number | string | null | undefined, now = new Date()): string {
  const d = toDate(at);
  if (!d) return "";
  if (d.toDateString() === now.toDateString())
    return d.toLocaleTimeString("fr-CA", { hour: "numeric", minute: "2-digit" });
  return d.toLocaleDateString("fr-CA", { day: "numeric", month: "short" });
}
